export default __webpack_public_path__ + "static/24-f8efa0c0b96d69bc021f591bfab81681.png";